import { Card } from "antd";
import type { ReactNode } from "react";

import { sectionSurface } from "@/shared/config";

/**
 * Карточка раздела с иконкой в заголовке.
 *
 * Обёртка, а не голый `Card`, ради одной вещи: иконка в `title` должна везде
 * быть одного размера и на одной подложке. Собранная инлайном, она на
 * «Начислениях» получалась на четыре пикселя крупнее, чем на «Настройках».
 */
export function SectionCard({
  color,
  icon = null,
  title = null,
  extra = null,
  bodyPadding,
  children,
}: {
  color: string;
  icon?: ReactNode;
  title?: ReactNode;
  extra?: ReactNode;
  /** Ноль — когда внутри таблица: у неё свои отступы в ячейках. */
  bodyPadding?: number;
  children: ReactNode;
}) {
  return (
    <Card
      style={{ height: "100%" }}
      styles={bodyPadding === undefined ? undefined : { body: { padding: bodyPadding } }}
      title={
        title === null ? undefined : (
          <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
            {icon !== null && (
              <span
                aria-hidden
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 24,
                  height: 24,
                  borderRadius: 7,
                  background: sectionSurface(color),
                  color,
                  fontSize: 14,
                }}
              >
                {icon}
              </span>
            )}
            {title}
          </span>
        )
      }
      extra={extra}
    >
      {children}
    </Card>
  );
}
